firebird.controller('betaSettingsCtrl', [
    '$rootScope',
    '$scope',
    'logService',
    'storageService',
    'attendeeService',
    'configService',
    'socketService',
    'betaSettingsService',
    function (
        $rootScope,
        $scope,
        logService,
        storageService,
        attendeeService,
        configService,
        socketService,
        betaSettingsService
    ) {
        var self = this;

        self.videoFilterValue = null;
        self.blurWebcamChecked = false;
        self.hostLayoutLockChecked = false;

        self.cancel = cancel;
        self.save = save;
        self.initSettings = initSettings;

        self.onVideoFilterToggled = onVideoFilterToggled;
        self.onVideoFilterChanged = onVideoFilterChanged;

        self.isHost = attendeeService.getIsHost();

        self.saveLayoutLock = saveLayoutLock;

        self.shouldShowSetting = shouldShowSetting;

        $scope.$on('video-filter-changed', onVideoFilterChanged);
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);
        $scope.$on('advanced-settings-changed', onAdvancedSettingsChanged);

        init();

        ////////////////////////

        function init() {
            logService.log('betaSettingsCtrl init');
            self.initSettings();
        }

        function initSettings() {
            self.videoFilterValue = storageService.get('videoFilter');
            if (self.videoFilterValue && self.videoFilterValue.startsWith('change-bg:blob:')) {
                self.videoFilterValue = null; // do not load blob url from last time.
            }
            self.blurWebcamChecked = !!self.videoFilterValue;
            self.hostLayoutLockChecked = configService.isLayoutLockLocked();
        }

        function save() {
            var previous = storageService.get('videoFilter');
            logService.log('betaSettingsCtrl save ' + !!previous + ' => ' + !!self.videoFilterValue);

            // If there has been a change
            if (previous !== self.videoFilterValue) {
                // Store value
                if (self.videoFilterValue) {
                    storageService.set('videoFilter', self.videoFilterValue);
                } else {
                    storageService.remove('videoFilter');
                }

                // Broadcast change event
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: self.videoFilterValue
                });
            }

            self.saveLayoutLock();
        }

        function saveLayoutLock() {
            var previous = configService.isLayoutLockLocked();
            if (previous !== self.hostLayoutLockChecked) {
                logService.log('saveLayoutLock ' + previous + ' => ' + self.layoutLockEnabled);
                // Do not save in local storage, as this is to be stored at/retrieved from server.
                socketService.send({
                    message: 'update-meeting-sfupayload',
                    data: { layoutLock: self.hostLayoutLockChecked ? 'locked' : 'available' }
                });
            }
        }

        function onVideoFilterToggled() {
            if (self.blurWebcamChecked) {
                self.videoFilterValue = 'blur-bg';
            } else {
                self.videoFilterValue = null;
            }
        }

        function cancel() {
            self.initSettings();
        }

        function onVideoFilterChanged(evt, msg) {
            logService.log('betaSettingsCtrl video-filter-changed', msg);
            self.blurWebcamChecked = !!msg.newValue;
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'beta-settings';

                if (data.openedTab === tabName) {
                    logService.log('beta Settings Tab opened');
                } else if (data.closedTab === tabName) {
                    logService.log('beta Settings Tab closed');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data && data.applyChanges) {
                logService.log('Beta Settings - applying changes');
                self.save();
            } else {
                logService.log('Beta Settings - closing without applying changes');
                self.cancel();
            }
        }

        function onAdvancedSettingsChanged() {
            self.hostLayoutLockChecked = configService.isLayoutLockLocked();
            digest();
        }

        function shouldShowSetting(settingName) {
            return !!betaSettingsService.getAvailableSettings()[settingName];
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
